
import { Outlet } from 'react-router-dom';
import PageTransition from '../PageTransition';
import { useLocation } from 'react-router-dom';

interface ContentAreaProps {
  children?: React.ReactNode;
}

export const ContentArea = ({ children }: ContentAreaProps) => {
  const location = useLocation();
  const isChatPage = location.pathname === '/app/chat';
  
  if (isChatPage) {
    return (
      <main className="flex-1 w-full relative">
        <div className="h-full">
          <PageTransition>
            {children || <Outlet />}
          </PageTransition>
        </div>
      </main>
    );
  }
  
  return (
    <main className="flex-1 w-full relative">
      <div className="h-full overflow-y-auto">
        <div className="container mx-auto px-4 py-4">
          <PageTransition>
            {children || <Outlet />}
          </PageTransition>
        </div>
      </div>
    </main>
  );
};
